module.exports = __webpack_public_path__ + "img/87d9bc2623a64648aa0a25a34d7082fe-1440.1eea2ccd.png";